import {HttpHandler} from "../../../utils/handler/HttpHandler";

export class BilateralLoanService {
    constructor() {
        this.httpHandler = new HttpHandler();
        this.axiosInstance = this.httpHandler.createInstance('/bilateral/loan');
    }

    getLoanDetail(loanId, withCollateralDetail){
        return this.axiosInstance({
            url: '/' + loanId,
            method: 'get',
            params: {
                withCollateralDetail: withCollateralDetail ?? false,
            }
        }).then(res => res);
    }

    saveCollateralsArrangement(params) {
        return this.axiosInstance({
            url: '/arrangement/' + params.loanId + '/' + params.borrowerAccount,
            method: 'post',
            data: {
                collateralMovementList: params.collateralsToAssign
            }
        }).then(res => res);
    }

    getLoanInstructions(loanId){
        return this.axiosInstance({
            url: '/' + loanId + '/instruction',
            method: 'get'
        }).then(res => res);
    }

    getLoanLogHistory(loanId){
        return this.axiosInstance({
            url: '/' + loanId + '/log',
            method: 'get',
        }).then(res => res);
    }

}